import { ApiError } from '@/lib/api-client.ts';

// Permission errors won't resolve by retrying, so SWR should stop after the
// first failure instead of re-firing onError on a backoff loop.
const PERMISSION_ERROR_STATUSES = new Set([401, 403]);

export const isPermissionError = (error: unknown): boolean =>
    error instanceof ApiError && PERMISSION_ERROR_STATUSES.has(error.status);
